import { startScrollSpy } from '@earthpeople/scroll-spy/es5'

export default function scrollArticle () {
  const subscribe = startScrollSpy()

  const options = {
    root: null,
    rootMargin: '0px',
    threshold: [0]
  }

  const elBody = document.querySelector('body')
  const articleSectionsArr = document.querySelectorAll('.ArticleSection')
  const elList = document.querySelector('.IndentList')
  const listItemArr = document.querySelectorAll('.IndentList-item')
  const articleNavigation = document.querySelector('.CourseArticleNavigation')
  const chapterNavigation = document.querySelector('.ChapterNavigation')
  const courseSidebarText = document.querySelector('.CourseSidebarToggle-text')

  if (elList) {
    const elListActive = document.createElement("span")
    const articleEnd = articleNavigation ? articleNavigation : chapterNavigation

    let currentMostVisible = null
    let previousMostVisible = null

    elList.appendChild(elListActive)
    elListActive.classList.add('IndentList-active')

    if (window.pageYOffset === 0) {
      listItemArr[0].classList.add('IndentList-item--active')
    }

    subscribe('scroll', event => {
      const {
        vh,
        scrollTop
      } = event

      const navigationY = articleEnd.getBoundingClientRect().top

      if (navigationY - vh <= 0) {
        elBody.classList.add('page-scroll-bottom')
      } else {
        elBody.classList.remove('page-scroll-bottom')
      }

      const sectionObserverCallback = (entries, observer) => {
        let currentMostVisibleRatio = null
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.intersectionRatio > 0.3) {
            if (entry.intersectionRatio > currentMostVisibleRatio) {
              currentMostVisible = entry.target
              currentMostVisibleRatio = entry.intersectionRatio
            }
          }
        })

        if (currentMostVisible !== previousMostVisible) {
          for (let i = 0; i < listItemArr.length; i++) {
            if (i === parseInt(currentMostVisible.dataset.sectionId, 10)) {
              const itemTop = listItemArr[i].getBoundingClientRect().top
              const parentTop = listItemArr[i].parentNode.getBoundingClientRect().top
              elListActive.style.top = itemTop - parentTop + 'px'
              listItemArr[i].classList.add('IndentList-item--active')
              courseSidebarText.textContent = currentMostVisible.querySelector('.ArticleSection-title').textContent
            } else {
              listItemArr[i].classList.remove('IndentList-item--active')
            }
          }
          previousMostVisible = currentMostVisible
        }

      }

      const sectionObserver = new IntersectionObserver(sectionObserverCallback, options)
      for (let i = 0; i < articleSectionsArr.length; i++) {
        articleSectionsArr[i].dataset.sectionId = `${i}`
        sectionObserver.observe(articleSectionsArr[i])
      }
    })
  }
}
